import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
// import "semantic-ui-css/semantic.min.css";

export default function CareerForm({ selectedJob, selectedJobStatus }) {
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("India");
  const [serverError, setServerError] = useState("");

  const handleSelect = (gender) => {
    setSelectedGender(gender);
  };
  const [errors, setErrors] = useState({});

  const handleSelectGender = (gender) => setSelectedGender(gender);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    coverLetterText: "",
    resume: null,
  });

  // Email validation function
  const validateEmail = (email) => {
    const regex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    return regex.test(email);
  };

  const validateForm = () => {
    let formErrors = {};

    // Name: required + min length
    if (!formData.name.trim()) {
      formErrors.name = "Name is required";
    } else if (formData.name.trim().length < 3) {
      formErrors.name = "Name must be at least 3 characters";
    }

    // Email: required + regex
    if (!formData.email.trim()) {
      formErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      formErrors.email = "Enter a valid email";
    }

    // Resume: required + type
    if (!formData.resume) {
      formErrors.resume = "Resume is required";
    }

    // Gender: required
    if (!selectedGender) {
      formErrors.gender = "Please select a gender";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    // Validate email
    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address.");
      setIsSubmitting(false);
      return;
    }

    // Create form data for both requests
    const formDataWithJob = new FormData();
    formDataWithJob.append("name", formData.name);
    formDataWithJob.append("email", formData.email);
    formDataWithJob.append("phone", formData.phone);
    formDataWithJob.append("coverLetterText", formData.coverLetterText);
    formDataWithJob.append("resume", formData.resume);
    formDataWithJob.append("job_role", selectedJob);

    const formDataForResumesApi = new FormData();
    formDataForResumesApi.append("name", formData.name);
    formDataForResumesApi.append("gender", selectedGender.toLowerCase());
    formDataForResumesApi.append("email", formData.email);
    formDataForResumesApi.append("phone", formData.phone);
    formDataForResumesApi.append("country", selectedCountry);
    formDataForResumesApi.append("coverLetter", formData.coverLetterText);
    formDataForResumesApi.append("role", selectedJob);

    formDataForResumesApi.append("status", "new");
    formDataForResumesApi.append("file", formData.resume);

    try {
      const responseResume = await fetch(
        `${process.env.REACT_APP_API}/starLabs/resumes`,
        {
          method: "POST",
          body: formDataForResumesApi,
        }
      );
      const data = await responseResume.json();

      if (responseResume.ok) {
        setIsSubmitted(true);
        setServerError(""); // clear any previous server error
      } else {
        if (
          responseResume.status === 409 &&
          data.message?.includes("already been submitted")
        ) {
          setServerError("You have already applied for this job.");
        } else {
          toast.error("Failed to submit application to resumes API");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error submitting the application");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handlePhoneChange = (value, data) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
    }));

    if (data?.name) {
      setSelectedCountry(data.name);
      console.log(data.name);
    }
  };
  useEffect(() => {
    const preventPageScrollOnDropdown = (e) => {
      const dropdown = document.querySelector(".custom-dropdown");
      if (dropdown && dropdown.contains(e.target)) {
        e.stopPropagation();
      }
    };

    // Attach the event
    document.addEventListener("wheel", preventPageScrollOnDropdown, {
      passive: false,
    });

    // Clean up on unmount
    return () => {
      document.removeEventListener("wheel", preventPageScrollOnDropdown);
    };
  }, []);

  const thankYouMessage = (
    <div className="flex items-center justify-center h-screen">
      <div className="p-1 rounded shadow-lg backdrop-blur-[16px] backdrop-saturate-[180%] bg-[rgba(71,71,71,0.38)]">
        <div className="flex flex-col items-center p-4 space-y-2 bg-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-green-600 w-28 h-28"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
            Thank You!
          </h1>
          <p>
            Thank you for your interest! Check your email for a link to the
            guide.
          </p>
          <a
            href="/careers"
            className="inline-flex items-center px-4 py-2 text-white bg-indigo-600 border border-indigo-600 rounded-full hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
              />
            </svg>
            <span className="text-sm font-medium">Explore More</span>
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div className="px-2 space-y-4 xs:px-4 md:px-1 lg:px-5 ">
      {isSubmitted ? (
        thankYouMessage // Render the thank-you message if submitted
      ) : (
        <>
          <ToastContainer />
          <h3 className="mb-4 text-2xl font-semibold text-center text-green-400">
            Apply for {selectedJob}
          </h3>
          {selectedJobStatus === "active" ? (
            <form
              className="px-5 pt-12 space-y-7 md:px-2 text-white/80"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div className="">
                <label
                  htmlFor="modal-name"
                  className="block text-sm font-medium sm:text-base md:text-lg "
                >
                  Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="modal-name"
                  name="name"
                  placeholder="Enter a Name"
                  className="w-full px-4 py-2 mt-3 bg-black border border-gray-400 rounded-lg"
                  onChange={handleInputChange}
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="modal-email"
                  className="block text-sm font-medium sm:text-base md:text-lg "
                >
                  E-Mail<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="modal-email"
                  name="email"
                  placeholder="Enter E-Mail"
                  className="w-full px-4 py-2 mt-3 bg-black border border-gray-400 rounded-lg"
                  onChange={handleInputChange}
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="modal-resume"
                  className="block text-sm font-medium md:text-lg"
                >
                  Upload Resume<span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  onChange={handleInputChange}
                  name="resume"
                  id="resume"
                  accept=".pdf,.doc,.docx"
                  className="block w-full px-4 py-2 mt-3 bg-black border border-gray-400 rounded-lg file:bg-black file:text-white file:border-0 file:me-4 file:py-3 file:px-4"
                />
                {errors.resume && (
                  <p className="text-red-500 text-sm mt-1">{errors.resume}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="modal-cover-letter-text"
                  className="block text-sm font-medium md:text-lg "
                >
                  Cover Letter
                </label>
                <textarea
                  id="modal-cover-letter-text"
                  name="coverLetterText"
                  rows="4"
                  className="w-full px-4 py-2 mt-3 bg-black border border-gray-400 rounded-lg"
                  placeholder="Write your cover letter here..."
                  onChange={handleInputChange}
                ></textarea>
              </div>
              <div>
                <label
                  htmlFor="modal-cover-letter-text"
                  className="block text-sm font-medium md:text-lg "
                >
                  Gender<span className="text-red-500">*</span>
                </label>
                <div className="flex mt-3 border border-gray-500 rounded-lg bg-black overflow-hidden w-fit shadow-md">
                  {["Male", "Female", "Other"].map((gender, index) => (
                    <div
                      key={gender}
                      className={`px-6 py-2 cursor-pointer font-medium transition-all duration-200
      ${selectedGender === gender ? "text-black bg-green-500" : "text-white"} 
      hover:bg-green-100 hover:text-green-700
      ${index !== 0 ? "border-l border-gray-500" : ""}`}
                      onClick={() => handleSelect(gender)}
                    >
                      {gender}
                    </div>
                  ))}
                </div>
                {errors.gender && (
                  <p className="text-red-500 text-sm mt-1">{errors.gender}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="modal-phone"
                  className="block text-sm font-medium sm:text-base md:text-lg"
                >
                  Contact Number
                </label>
                <PhoneInput
                  country={"in"} // Default country code
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  containerClass="w-full mt-3"
                  inputClass="!w-full !h-11 !bg-black !border !border-gray-400 !rounded-lg !text-white/80 !pl-14"
                  buttonClass="!bg-transparent !text-white"
                  dropdownClass="!bg-black !text-white custom-dropdown" // Add this class
                  searchClass="!bg-black !text-white !border-gray-400"
                />
              </div>

              <div className="text-center text-[0.84rem]">
                <p>
                  "I Agree To The{" "}
                  <Link to="/privacypolicy" className="text-blue-500 underline">
                    Privacy Policy
                  </Link>{" "}
                  And{" "}
                  <Link
                    to="/termsofservices"
                    className="text-blue-500 underline"
                  >
                    Terms Of Services
                  </Link>
                  "
                </p>
              </div>
              {serverError && (
                <p className="text-red-500 text-sm text-center">
                  {serverError}
                </p>
              )}

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="px-4 py-2 text-black bg-green-400 rounded-lg hover:bg-blue-600"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          ) : (
            <div className="flex justify-center">
              <div className="text-center bg-red-500/10 border mt-40 border-red-500 text-red-400 px-6 py-6 rounded-lg shadow-md max-w-lg">
                <span className="block text-lg font-semibold mb-2">
                  This job posting has expired
                </span>
                <span className="block text-sm text-white/80 mb-4">
                  Don’t worry — check out our other openings that might be a
                  perfect fit for you!
                </span>
                <Link
                  to="/careers"
                  className="inline-block px-5 py-2 bg-green-500 text-black font-medium rounded-lg hover:bg-green-400 transition-all duration-200"
                >
                  View Other Openings
                </Link>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
